import { useCallback, useEffect, useState } from 'react';
import { isSsr } from '../../utils/index.js';
const getIsEnabled = timeOffMs => {
  if (isSsr) {
    return false;
  }
  const dismissedAt = localStorage.getItem('hotlineBarFixedDismissedAt');
  if (!dismissedAt) {
    return true;
  }
  if (Date.now() - Number(dismissedAt) > timeOffMs) {
    localStorage.removeItem('hotlineBarFixedDismissedAt');
    return true;
  }
  return false;
};
export const useHotlineBarFixed = ({
  offset = 1,
  timeOff = 86_400_000
} = {}) => {
  const [scrolledPastOffset, setScrolledPassedOffset] = useState(false);
  const [enabled, setEnabled] = useState(getIsEnabled(timeOff));
  useEffect(() => {
    if (isSsr) {
      return;
    }
    const handleScroll = () => {
      setScrolledPassedOffset(window.scrollY > offset);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offset]);
  const dismiss = useCallback(() => {
    try {
      localStorage.setItem('hotlineBarFixedDismissedAt', String(Date.now()));
    } catch {}
    setEnabled(false);
  }, []);
  return {
    enabled,
    visible: scrolledPastOffset && enabled,
    dismiss
  };
};